<script lang="ts" setup>
import { toRefs } from '@vueuse/core'
import type { MenuItem } from '~/types'

interface Props {
  menuItem: MenuItem.Model
}

const props = defineProps<Props>()
const { menuItem } = toRefs(props)
const { value, target, icon, name } = useMenuItem(menuItem)
</script>

<template>
  <div class="menu-item">
    <NuxtLink
      v-if="value"
      :href="value"
      :target="target"
      class="menu-item__link"
    >
      <div
        v-if="icon"
        class="menu-item__icon-wrapper"
      >
        <UIImage
          :image="icon"
          class="menu-item__icon"
        />
      </div>
      {{ name }}
    </NuxtLink>
    <span
      v-else-if="icon"
      class="menu-item__link"
    >
      <div class="menu-item__icon-wrapper">
        <UIImage
          :image="icon"
          class="menu-item__icon"
        />
      </div>
      {{ name }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.menu-item {
  @apply mb-[10px];

  &__link {
    @apply text-[15px] text-white/80 inline-flex items-center my-[5px] leading-[1] decoration-transparent underline underline-offset-4 transition-colors duration-300;
    @apply hover:text-white hover:decoration-white;
  }

  &__icon-wrapper {
    @apply mr-[20px] w-[50px] h-[50px] rounded-full flex items-center justify-center border border-white/20;
  }

  &__icon {
    @apply w-[26px] h-[26px] object-contain;
  }
}
</style>
